import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setModelShow,
  authActions,
} from "../../redux/athentication/Athentication";
import {
  pageStatusChange,
  setuserIdRemove,
} from "../../redux/property/PropertySlice";
import { searchPost, setsearchObjects } from "../../redux/search/SearchSlice";
import { Baseurl } from "../../config/BaseUrl";
import axios from "axios";
import {
  FiChevronDown,
  FiChevronUp,
  FiPlus,
  FiUser,
  FiHeadphones,
  FiX,
  FiGrid,
  FiPackage,
  FiHome,
  FiCheckCircle,
  FiPhoneCall,
  FiLogOut,
  FiChevronRight,
} from "react-icons/fi";
import { MdCall, MdPhoneCallback } from "react-icons/md";
import { LuSearch } from "react-icons/lu";
import { RxCross2 } from "react-icons/rx";
import "../../components/layouts/HeaderNew.css";

const HeaderSearch = (props) => {
  const { loginData, isAuth } = useSelector((store) => store.Athentication);
  const { searchObjects } = useSelector((store) => store.Search);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchWrapRef = useRef(null);

  const [menubar, setMenubar] = useState(false);
  const [propertyId, setPropertyId] = useState("");
  const [searchError, setSearchError] = useState("");

  const [selectedsupcat, setSelectedsupcat] = useState("Residential");
  const [selectedItem, setSelectedItem] = useState("Buy");
  const [isCatDropdownOpen, setIsCatDropdownOpen] = useState(false);

  const [search, setSearch] = useState("");
  const [showResults, setShowResults] = useState(false);
  const [searchArray, setSearchArray] = useState(["Hyderabad"]);

  const [citylist, setCitylist] = useState([]);
  const [propertySearch, setPropertySearch] = useState([]);
  const [showAllApart, setShowAllApart] = useState([]);
  const [propertySearchShow, setPropertySearchShow] = useState([]);
  const [propertyShowByApart, setPropertyShowByApart] = useState([]);
  const [propertySearchShowByCity, setPropertySearchShowByCity] = useState([]);
  const [propertySearchProject, setPropertySearchProject] = useState([]);

  // Sync props from SearchPropertyy
  useEffect(() => {
    if (props.changeSupCat) setSelectedsupcat(props.changeSupCat);
    if (props.changeCat) {
      setSelectedItem(props.changeCat === "Sell" ? "Buy" : props.changeCat);
    }
    if (Array.isArray(props.searchArray)) {
      setSearchArray([...props.searchArray]);
    }
  }, [props.searchArray, props.changeCat, props.changeSupCat]);

  // Click outside to close dropdowns
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchWrapRef.current && !searchWrapRef.current.contains(e.target)) {
        setShowResults(false);
        setIsCatDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Fetch cities on mount
  useEffect(() => {
    const fetchCities = async () => {
      try {
        const url = `${Baseurl}/api/v1/property/allcities`;
        const res = await axios.get(url);
        if (res.data?.success) {
          setCitylist(res.data.cities || []);
        }
      } catch (error) { }
    };
    fetchCities();
  }, []);

  // Search input change & suggestion triggers
  const searchChange = (e) => {
    const val = e.target.value;
    setSearch(val);
    if (val.trim().length >= 2) {
      setShowResults(true);
    }
  };

  useEffect(() => {
    if (!search || search.length < 2) return;

    const fetchSuggestions = async () => {
      try {
        const locRes = await axios.get(`${Baseurl}/api/v1/property/localitieswithcity`);
        if (locRes.data?.success) {
          setPropertySearch(locRes.data.locality || []);
        }
      } catch (e) { }

      try {
        const projRes = await axios.get(`${Baseurl}/api/v1/property/allPropertyproject/${search}`);
        if (projRes.data?.success) {
          setPropertySearchProject(projRes.data.properties || []);
        }
      } catch (e) { }

      try {
        const aptRes = await axios.get(`${Baseurl}/api/v1/property/apartmentswithcity`);
        if (aptRes.data?.success) {
          setShowAllApart(aptRes.data.apartment || []);
        }
      } catch (e) { }
    };

    fetchSuggestions();
  }, [search]);

  // Filter suggestion results
  useEffect(() => {
    if (search.trim()) {
      const q = search.toLowerCase();
      setPropertySearchShow(
        propertySearch.filter((item) => item.locality?.toLowerCase().includes(q)).slice(0, 5)
      );
      setPropertyShowByApart(
        showAllApart.filter((item) => item.apartment?.toLowerCase().includes(q)).slice(0, 5)
      );
      setPropertySearchShowByCity(
        citylist.filter((c) => c.toLowerCase().includes(q)).slice(0, 5)
      );
    }
  }, [search, propertySearch, showAllApart, citylist]);

  // Select suggestion items
  const storeCityAllInarray = (e, city) => {
    e.stopPropagation();
    const updated = [city];
    setSearchArray(updated);
    setSearch("");
    setShowResults(false);
    dispatch(setsearchObjects({ ...searchObjects, selectedCity: updated }));
    navigate(`/property-search/${selectedsupcat}/${selectedItem === "Buy" ? "Sell" : selectedItem}/All/${encodeURIComponent(city)}`);
  };

  const storeCityInarray = (e, data) => {
    e.stopPropagation();
    const updated = [data.locality];
    setSearchArray(updated);
    setSearch("");
    setShowResults(false);
    dispatch(setsearchObjects({ ...searchObjects, selectedCity: updated }));
    navigate(`/property-search/${selectedsupcat}/${selectedItem === "Buy" ? "Sell" : selectedItem}/All/${encodeURIComponent(data.locality)}`);
  };

  const storeAllApartInarray = (e, apart) => {
    e.stopPropagation();
    const updated = [apart.apartment];
    setSearchArray(updated);
    setSearch("");
    setShowResults(false);
    dispatch(setsearchObjects({ ...searchObjects, selectedCity: updated }));
    navigate(`/property-search/${selectedsupcat}/${selectedItem === "Buy" ? "Sell" : selectedItem}/All/${encodeURIComponent(apart.apartment)}`);
  };

  const projectRedirect = (e, data) => {
    e.preventDefault();
    setShowResults(false);
    navigate(`/project-info/${data.apartment}`);
    if (isAuth && loginData?._id) {
      dispatch(
        searchPost({
          userId: loginData._id,
          name: loginData.name,
          userMobile: loginData.mobile,
          propertyId: data._id,
          city: data.city,
          locality: data.locality,
          apartment: data.apartment,
        })
      );
    }
  };

  const selectRemoveClick = (data) => {
    const filterdata = searchArray.filter((item) => item !== data);
    setSearchArray(filterdata);
    if (props.setChangeSupCat) props.setChangeSupCat(selectedsupcat);
    if (props.setChangeCat) {
      props.setChangeCat(selectedItem === "Buy" ? "Sell" : selectedItem);
    }
    dispatch(
      setsearchObjects({
        ...searchObjects,
        selectedCity: filterdata,
      })
    );
  };

  const handleMenuCategory = (supCat, catLabel) => {
    setSelectedsupcat(supCat);
    setSelectedItem(catLabel);
    setIsCatDropdownOpen(false);

    const mappedCat = catLabel === "Buy" ? "Sell" : catLabel;
    if (props.setChangeSupCat) props.setChangeSupCat(supCat);
    if (props.setChangeCat) props.setChangeCat(mappedCat);

    const currentCity = searchArray[0] || "Hyderabad";
    navigate(`/property-search/${supCat}/${mappedCat}/All/${encodeURIComponent(currentCity)}`);
  };

  const advanceSearchClick = () => {
    if (props.setChangeSupCat) props.setChangeSupCat(selectedsupcat);
    const mappedCat = selectedItem === "Buy" ? "Sell" : selectedItem;
    if (props.setChangeCat) props.setChangeCat(mappedCat);

    let updatedCityArray = [...searchArray];
    if (search.trim() && !updatedCityArray.includes(search.trim())) {
      updatedCityArray = [search.trim()];
      setSearchArray(updatedCityArray);
      setSearch("");
    }
    setShowResults(false);
    dispatch(
      setsearchObjects({
        ...searchObjects,
        selectedCity: updatedCityArray,
      })
    );
    navigate(`/property-search/${selectedsupcat}/${mappedCat}/All/${encodeURIComponent(updatedCityArray[0] || "Hyderabad")}`);
  };

  const logoutClick = () => {
    dispatch(authActions.signout());
    dispatch(setuserIdRemove());
    navigate("/");
    window.location.reload(false);
  };

  return (
    <>
      <header className="mgh-header-container">
        {/* Left: Logo */}
        <Link to="/" className="mgh-header-logo">
          <img
            src="/assets/images/logo4.png"
            alt="EwRealty"
            className="mgh-logo-img"
          />
        </Link>

        {/* Center: Search Bar */}
        <div className="mgh-nav-search-bar" ref={searchWrapRef}>
          {/* Category Dropdown */}
          <div className="mgh-nav-search-dropdown-wrap">
            <button
              type="button"
              className="mgh-nav-search-cat-btn"
              onClick={() => setIsCatDropdownOpen(!isCatDropdownOpen)}
            >
              <span>{selectedItem}</span>
              {isCatDropdownOpen ? <FiChevronUp /> : <FiChevronDown />}
            </button>
            {isCatDropdownOpen && (
              <div className="mgh-nav-cat-menu">
                <div className="mgh-nav-cat-group-label">Residential</div>
                <div
                  className={`mgh-nav-cat-option ${selectedItem === "Buy" && selectedsupcat === "Residential" ? "active" : ""}`}
                  onClick={() => handleMenuCategory("Residential", "Buy")}
                >
                  Buy
                </div>
                <div
                  className={`mgh-nav-cat-option ${selectedItem === "Rent" && selectedsupcat === "Residential" ? "active" : ""}`}
                  onClick={() => handleMenuCategory("Residential", "Rent")}
                >
                  Rent
                </div>
                <div
                  className={`mgh-nav-cat-option ${selectedItem === "Pg" ? "active" : ""}`}
                  onClick={() => handleMenuCategory("Residential", "Pg")}
                >
                  PG / Co-Living
                </div>
                <div
                  className={`mgh-nav-cat-option ${selectedItem === "Projects" ? "active" : ""}`}
                  onClick={() => handleMenuCategory("Residential", "Projects")}
                >
                  Projects
                </div>

                <div className="mgh-nav-cat-group-label">Commercial</div>
                <div
                  className={`mgh-nav-cat-option ${selectedItem === "Buy" && selectedsupcat === "Commercial" ? "active" : ""}`}
                  onClick={() => handleMenuCategory("Commercial", "Buy")}
                >
                  Commercial Buy
                </div>
                <div
                  className={`mgh-nav-cat-option ${selectedItem === "Lease" ? "active" : ""}`}
                  onClick={() => handleMenuCategory("Commercial", "Lease")}
                >
                  Commercial Lease
                </div>
              </div>
            )}
          </div>

          <div className="mgh-nav-search-divider" />

          {/* Applied City Filter Chip (Orange Theme) */}
          {searchArray.length > 0 && (
            <div className="mgh-nav-search-chip">
              <span>{searchArray[0]}</span>
              <RxCross2
                className="mgh-nav-chip-remove"
                onClick={() => selectRemoveClick(searchArray[0])}
                title="Remove city filter"
              />
            </div>
          )}

          {/* Search Input */}
          <input
            type="text"
            className="mgh-nav-search-input"
            placeholder='Search "Hyderabad"'
            value={search}
            onChange={searchChange}
            onFocus={() => {
              if (search.trim().length >= 2) setShowResults(true);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") advanceSearchClick();
            }}
          />

          {/* Search Icon Submit Button */}
          <button
            type="button"
            className="mgh-nav-search-submit"
            onClick={advanceSearchClick}
            title="Search"
          >
            <LuSearch />
          </button>

          {/* Suggestions Dropdown */}
          {showResults &&
            (propertySearchShowByCity.length > 0 ||
              propertySearchShow.length > 0 ||
              propertyShowByApart.length > 0 ||
              propertySearchProject.length > 0) && (
              <div className="mgh-nav-suggestions">
                {propertySearchShowByCity.map((city, idx) => (
                  <div
                    key={`c-${idx}`}
                    className="mgh-nav-sugg-item"
                    onClick={(e) => storeCityAllInarray(e, city)}
                  >
                    <span>{city}</span>
                    <span className="mgh-nav-sugg-tag">City</span>
                  </div>
                ))}
                {propertySearchShow.map((data, idx) => (
                  <div
                    key={`l-${idx}`}
                    className="mgh-nav-sugg-item"
                    onClick={(e) => storeCityInarray(e, data)}
                  >
                    <span>
                      {data.locality}, {data.city}
                    </span>
                    <span className="mgh-nav-sugg-tag">Locality</span>
                  </div>
                ))}
                {propertyShowByApart.map((apart, idx) => (
                  <div
                    key={`a-${idx}`}
                    className="mgh-nav-sugg-item"
                    onClick={(e) => storeAllApartInarray(e, apart)}
                  >
                    <span>{apart.apartment}</span>
                    <span className="mgh-nav-sugg-tag">
                      {apart.subCategory || "Apartment"}
                    </span>
                  </div>
                ))}
                {propertySearchProject.map((data, idx) => (
                  <div
                    key={`p-${idx}`}
                    className="mgh-nav-sugg-item"
                    onClick={(e) => projectRedirect(e, data)}
                  >
                    <span>{data.apartment}</span>
                    <span className="mgh-nav-sugg-tag">Project</span>
                  </div>
                ))}
              </div>
            )}
        </div>

        {/* Right Group: Support, Profile, Post Property, Hamburger Menu */}
        <div className="mgh-header-right">
          {/* Headset / Support */}
          <div className="mgh-nav-item">
            <button
              type="button"
              className="mgh-headset-btn"
              title="Customer Support"
            >
              <FiHeadphones />
            </button>
            <div className="mgh-support-card">
              <div className="mgh-support-item">
                <div className="mgh-support-icon">
                  <MdCall />
                </div>
                <div className="mgh-support-info">
                  <h5>Toll Free | 9 AM - 8 PM IST</h5>
                  <p>+91 9063483711</p>
                </div>
              </div>
              <div
                className="mgh-support-item"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/contactus")}
              >
                <div
                  className="mgh-support-icon"
                  style={{ background: "#ecfdf5", color: "#059669" }}
                >
                  <MdPhoneCallback />
                </div>
                <div className="mgh-support-info">
                  <h5>Customer Helpdesk</h5>
                  <p>Request a Call Back</p>
                </div>
              </div>
            </div>
          </div>

          {/* User Profile / Sign In (Hidden on mobile search header, accessible via drawer) */}
          <div className="mgh-search-header-user">
            {isAuth ? (
              <div className="mgh-nav-item">
                <button type="button" className="mgh-user-btn">
                  <span>{loginData?.name || "User"}</span>
                  <FiChevronDown />
                </button>
                <div className="mgh-profile-dropdown">
                  <div
                    className="mgh-dropdown-link"
                    style={{ color: "#d97706", fontWeight: 700 }}
                    onClick={() => navigate("/dashboard")}
                  >
                    My MGH Dashboard
                  </div>
                  <div
                    className="mgh-dropdown-link"
                    onClick={() => {
                      navigate("/dashboard");
                      dispatch(pageStatusChange(4));
                    }}
                  >
                    Manage Listings
                  </div>
                  <div
                    className="mgh-dropdown-link"
                    onClick={() => {
                      navigate("/dashboard");
                      dispatch(pageStatusChange(21));
                    }}
                  >
                    View All Responses
                  </div>
                  <div
                    className="mgh-dropdown-link"
                    style={{
                      color: "#dc2626",
                      borderTop: "1px solid #f1f5f9",
                      marginTop: "4px",
                    }}
                    onClick={logoutClick}
                  >
                    Logout
                  </div>
                </div>
              </div>
            ) : (
              <button
                type="button"
                className="mgh-user-btn"
                onClick={() => navigate("/login")}
              >
                <FiUser style={{ fontSize: "16px", marginRight: "2px" }} />
                <span>Sign In</span>
              </button>
            )}
          </div>

          {/* Post Property Button (Brand Orange Pill with Free Badge) */}
          {isAuth ? (
            <Link to="/postPropertyHome" className="mgh-post-property-btn">
              <div className="mgh-plus-circle">
                <FiPlus />
              </div>
              <span className="mgh-post-btn-text">Post Property</span>
              <span className="mgh-post-btn-text-short">Post</span>
              <span className="mgh-free-pill">FREE</span>
            </Link>
          ) : (
            <button
              type="button"
              className="mgh-post-property-btn"
              onClick={() => navigate("/login")}
            >
              <div className="mgh-plus-circle">
                <FiPlus />
              </div>
              <span className="mgh-post-btn-text">Post Property</span>
              <span className="mgh-post-btn-text-short">Post</span>
              <span className="mgh-free-pill">FREE</span>
            </button>
          )}

          {/* 3 Horizontal Bars Hamburger Button */}
          <button
            type="button"
            className="mgh-menu-toggle-btn"
            onClick={() => setMenubar(!menubar)}
            title="Menu"
          >
            <span className="mgh-hamburger-bar" />
            <span className="mgh-hamburger-bar" />
            <span className="mgh-hamburger-bar" />
          </button>
        </div>
      </header>

      {/* Smooth Offcanvas Drawer Overlay */}
      <div
        className={`mgh-drawer-overlay ${menubar ? "active" : ""}`}
        onClick={() => setMenubar(false)}
      />

      {/* Smooth Sliding Drawer */}
      <div className={`mgh-drawer ${menubar ? "active" : ""}`}>
        <div className="mgh-drawer-header">
          <div className="mgh-drawer-brand">
            <img
              src="/assets/images/logo4.png"
              alt="EwRealty"
              className="mgh-drawer-logo"
            />
          </div>
          <button
            type="button"
            className="mgh-drawer-close-btn"
            onClick={() => setMenubar(false)}
            aria-label="Close Menu"
          >
            <FiX size={20} />
          </button>
        </div>

        <div className="mgh-drawer-body">
          <div className="mgh-drawer-user-card">
            <div className="mgh-drawer-avatar">
              <FiUser size={22} />
            </div>
            <div
              className="mgh-drawer-user-info"
              style={{
                textAlign: "left",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
              }}
            >
              <h4 style={{ textAlign: "left", width: "100%", margin: "0 0 2px 0" }}>
                {loginData?.name || "Welcome Guest"}
              </h4>
              <p style={{ textAlign: "left", width: "100%", margin: 0 }}>
                {isAuth
                  ? loginData?.email || loginData?.mobile || "Account active"
                  : "Sign in to manage your properties"}
              </p>
            </div>
            {!isAuth && (
              <button
                type="button"
                className="mgh-drawer-login-btn"
                onClick={() => {
                  setMenubar(false);
                  navigate("/login");
                }}
              >
                Sign In
              </button>
            )}
          </div>

          {/* Highlighted Post Property Card in Mobile Drawer */}
          <div className="mgh-drawer-post-card">
            <div className="mgh-drawer-post-badge">
              <span>EXCLUSIVE &bull; 100% FREE</span>
            </div>
            <h4>Sell or Rent Your Property Fast</h4>
            <p>Connect directly with genuine buyers with zero brokerage</p>
            <button
              type="button"
              className="mgh-drawer-post-cta"
              onClick={() => {
                setMenubar(false);
                if (isAuth) {
                  navigate("/postPropertyHome");
                } else {
                  navigate("/login");
                }
              }}
            >
              <div className="mgh-plus-circle">
                <FiPlus />
              </div>
              <span>Post Property Now</span>
              <span className="mgh-free-pill">FREE</span>
            </button>
          </div>

          <div className="mgh-drawer-section">
            <span className="mgh-drawer-section-title">Account & Dashboard</span>
            <ul className="mgh-drawer-nav-list">
              <li>
                <button
                  type="button"
                  className="mgh-drawer-nav-item mgh-drawer-nav-highlight"
                  onClick={() => {
                    setMenubar(false);
                    if (isAuth) {
                      navigate("/postPropertyHome");
                    } else {
                      navigate("/login");
                    }
                  }}
                >
                  <div className="mgh-drawer-icon-wrap" style={{ background: "#fff7ed", color: "#ea580c" }}>
                    <FiPlus size={18} />
                  </div>
                  <span style={{ fontWeight: 700, color: "#ea580c" }}>Post Property</span>
                  <span className="mgh-free-pill" style={{ marginLeft: "auto", marginRight: "6px" }}>FREE</span>
                  <FiChevronRight className="mgh-drawer-arrow" size={16} />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="mgh-drawer-nav-item"
                  onClick={() => {
                    navigate("/dashboard");
                    setMenubar(false);
                  }}
                >
                  <div className="mgh-drawer-icon-wrap">
                    <FiGrid size={18} />
                  </div>
                  <span>Dashboard Overview</span>
                  <FiChevronRight className="mgh-drawer-arrow" size={16} />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="mgh-drawer-nav-item"
                  onClick={() => {
                    navigate("/dashboard");
                    dispatch(pageStatusChange(9));
                    setMenubar(false);
                  }}
                >
                  <div className="mgh-drawer-icon-wrap">
                    <FiPackage size={18} />
                  </div>
                  <span>Packages & Plans</span>
                  <FiChevronRight className="mgh-drawer-arrow" size={16} />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="mgh-drawer-nav-item"
                  onClick={() => {
                    navigate("/dashboard");
                    dispatch(pageStatusChange(4));
                    setMenubar(false);
                  }}
                >
                  <div className="mgh-drawer-icon-wrap">
                    <FiHome size={18} />
                  </div>
                  <span>Your Properties</span>
                  <FiChevronRight className="mgh-drawer-arrow" size={16} />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="mgh-drawer-nav-item"
                  onClick={() => {
                    navigate("/dashboard");
                    dispatch(pageStatusChange(21));
                    setMenubar(false);
                  }}
                >
                  <div className="mgh-drawer-icon-wrap">
                    <FiCheckCircle size={18} />
                  </div>
                  <span>All Inquiries & Responses</span>
                  <FiChevronRight className="mgh-drawer-arrow" size={16} />
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mgh-drawer-footer">
          <a href="tel:+919063483711" className="mgh-drawer-support-box">
            <div className="mgh-drawer-support-icon">
              <FiPhoneCall size={18} />
            </div>
            <div className="mgh-drawer-support-text">
              <span>Toll Free Helpline</span>
              <strong>+91 90634 83711</strong>
            </div>
          </a>

          {isAuth && (
            <button
              type="button"
              className="mgh-drawer-logout-btn"
              onClick={logoutClick}
            >
              <FiLogOut size={16} />
              <span>Sign Out</span>
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default HeaderSearch;
